import React, { Component } from "react";
import { BASE_URL } from "../common/common";

const API_URL = BASE_URL;
const MAX_IMAGE_SIZE = 3 * 1024 * 1024; // 3 MB

const imgUrl = (path) => {
  if (!path) return null;
  if (path.startsWith("http")) return `${path}?ngrok-skip-browser-warning=true`;
  const cleanPath = path.startsWith("/") ? path.slice(1) : path;
  return `${API_URL}/${cleanPath}?ngrok-skip-browser-warning=true`;
};

// ── Rich Text Editor ────────────────────────
class RichTextEditor extends Component {
  constructor(props) {
    super(props);
    this.ref = React.createRef();
    this.state = { showLinkInput: false, linkUrl: "" };
  }

  componentDidMount() {
    if (this.ref.current) this.ref.current.innerHTML = this.props.value || "";
  }

  exec = (cmd, value = null) => {
    this.ref.current.focus();
    document.execCommand(cmd, false, value);
    this.notify();
  };

  notify = () => {
    if (this.ref.current) this.props.onChange(this.ref.current.innerHTML);
  };
  handleInput = () => this.notify();

  insertLink = () => {
    const { linkUrl } = this.state;
    if (!linkUrl.trim()) return;
    const url = linkUrl.startsWith("http") ? linkUrl : `https://${linkUrl}`;
    this.exec("createLink", url);
    this.setState({ showLinkInput: false, linkUrl: "" });
  };

  render() {
    const { showLinkInput, linkUrl } = this.state;
    return (
      <div style={rt.wrapper}>
        <div style={rt.toolbar}>
          <select
            style={rt.select}
            onChange={(e) => {
              this.exec("formatBlock", e.target.value);
              e.target.value = "p";
            }}
          >
            <option value="p">Paragraph</option>
            <option value="h1">Heading 1</option>
            <option value="h2">Heading 2</option>
            <option value="h3">Heading 3</option>
            <option value="h4">Heading 4</option>
            <option value="pre">Code Block</option>
            <option value="blockquote">Blockquote</option>
          </select>
          <select
            style={rt.select}
            onChange={(e) => {
              this.exec("fontSize", e.target.value);
              e.target.value = "";
            }}
          >
            <option value="">Size</option>
            {[1, 2, 3, 4, 5, 6, 7].map((n) => (
              <option key={n} value={n}>
                {["8px", "10px", "12px", "14px", "18px", "24px", "36px"][n - 1]}
              </option>
            ))}
          </select>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("bold")}
          >
            <b>B</b>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("italic")}
          >
            <i>I</i>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("underline")}
          >
            <u>U</u>
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("strikeThrough")}
          >
            <s>S</s>
          </button>
          <span style={rt.sep} />
          <label style={rt.colorLabel}>
            A
            <input
              type="color"
              style={rt.colorInput}
              onChange={(e) => this.exec("foreColor", e.target.value)}
            />
          </label>
          <label style={{ ...rt.colorLabel, background: "#ffe082" }}>
            H
            <input
              type="color"
              style={rt.colorInput}
              onChange={(e) => this.exec("hiliteColor", e.target.value)}
            />
          </label>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyLeft")}
          >
            &#8676;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyCenter")}
          >
            &#8652;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyRight")}
          >
            &#8677;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("justifyFull")}
          >
            &#8801;
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertUnorderedList")}
          >
            • List
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertOrderedList")}
          >
            1. List
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("indent")}
          >
            &#8677;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("outdent")}
          >
            &#8676;
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() =>
              this.setState((p) => ({ showLinkInput: !p.showLinkInput }))
            }
          >
            Link
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("unlink")}
          >
            Unlink
          </button>
          <span style={rt.sep} />
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("insertHorizontalRule")}
          >
            &#8213;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("removeFormat")}
          >
            Clear
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("undo")}
          >
            &#8617;
          </button>
          <button
            type="button"
            style={rt.btn}
            onClick={() => this.exec("redo")}
          >
            &#8618;
          </button>
        </div>
        {showLinkInput && (
          <div style={rt.linkRow}>
            <input
              type="text"
              placeholder="https://example.com"
              value={linkUrl}
              onChange={(e) => this.setState({ linkUrl: e.target.value })}
              onKeyDown={(e) => {
                if (e.key === "Enter") this.insertLink();
              }}
              style={rt.linkInput}
            />
            <button type="button" style={rt.linkBtn} onClick={this.insertLink}>
              Insert
            </button>
            <button
              type="button"
              style={rt.cancelBtn}
              onClick={() =>
                this.setState({ showLinkInput: false, linkUrl: "" })
              }
            >
              Cancel
            </button>
          </div>
        )}
        <div
          ref={this.ref}
          contentEditable
          suppressContentEditableWarning
          onInput={this.handleInput}
          style={rt.editor}
        />
        <div style={rt.footer}>
          Characters: {this.ref.current ? this.ref.current.innerText.length : 0}
          <span style={{ marginLeft: "12px", color: "#bbb" }}>
            Tip: Select text first, then apply formatting
          </span>
        </div>
      </div>
    );
  }
}

const rt = {
  wrapper: {
    border: "1px solid #ddd",
    borderRadius: "8px",
    overflow: "hidden",
  },
  toolbar: {
    display: "flex",
    flexWrap: "wrap",
    gap: "3px",
    padding: "8px 10px",
    background: "#f8f8f8",
    borderBottom: "1px solid #e8e8e8",
    alignItems: "center",
  },
  btn: {
    padding: "4px 9px",
    background: "white",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    minWidth: "28px",
    textAlign: "center",
  },
  select: {
    padding: "4px 6px",
    border: "1px solid #ddd",
    borderRadius: "4px",
    fontSize: "12px",
    background: "white",
    cursor: "pointer",
    outline: "none",
  },
  sep: {
    width: "1px",
    height: "20px",
    background: "#ddd",
    margin: "0 3px",
    flexShrink: 0,
  },
  colorLabel: {
    padding: "3px 8px",
    background: "#fff",
    border: "1px solid #ddd",
    borderRadius: "4px",
    cursor: "pointer",
    fontSize: "12px",
    fontWeight: "700",
    position: "relative",
    display: "flex",
    alignItems: "center",
  },
  colorInput: {
    position: "absolute",
    opacity: 0,
    width: "100%",
    height: "100%",
    top: 0,
    left: 0,
    cursor: "pointer",
    border: "none",
  },
  linkRow: {
    display: "flex",
    gap: "8px",
    padding: "8px 10px",
    background: "#f0f7ff",
    borderBottom: "1px solid #bbdefb",
    alignItems: "center",
  },
  linkInput: {
    flex: 1,
    padding: "6px 10px",
    border: "1px solid #bbdefb",
    borderRadius: "6px",
    fontSize: "13px",
    outline: "none",
  },
  linkBtn: {
    padding: "6px 14px",
    background: "#1565c0",
    color: "#fff",
    border: "none",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
    fontWeight: "600",
  },
  cancelBtn: {
    padding: "6px 14px",
    background: "#f0f2f5",
    color: "#555",
    border: "1px solid #ddd",
    borderRadius: "6px",
    fontSize: "12px",
    cursor: "pointer",
  },
  editor: {
    minHeight: "180px",
    padding: "16px",
    fontSize: "14px",
    lineHeight: "1.8",
    outline: "none",
    fontFamily: "Arial, sans-serif",
    background: "white",
  },
  footer: {
    padding: "6px 12px",
    background: "#fafafa",
    borderTop: "1px solid #f0f0f0",
    fontSize: "11px",
    color: "#aaa",
    display: "flex",
    alignItems: "center",
  },
};


const emptySocialForm = () => ({
  platform     : "",
  url          : "",
  iconPreview  : null,
  iconFile     : null,
  saving       : false,
});

// ── Social platform presets ──────────────────
const SOCIAL_PLATFORMS = [
  { label: "Facebook",  icon: "f", color: "#1877f2" },
  { label: "Instagram", icon: "in", color: "#e1306c" },
  { label: "YouTube",   icon: "yt", color: "#ff0000" },
  { label: "LinkedIn",  icon: "li", color: "#0077b5" },
  { label: "Twitter/X", icon: "x",  color: "#000000" },
  { label: "Custom",    icon: "?",  color: "#888888" },
];

class Settings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab : "logo",

      // ── Logo Section
      logoData          : null,
      logoLoading       : false,
      logoSaving        : false,
      headerLogoPreview : null,
      headerLogoFile    : null,
      footerLogoPreview : null,
      footerLogoFile    : null,
      footerContent     : "",

      // ── Social Media
      socialView    : "list",
      socialList    : [],
      socialLoading : false,
      socialForm    : emptySocialForm(),
      editingSocial : null,

      // ── Popup
      popupData        : null,
      popupLoading     : false,
      popupSaving      : false,
      popupPreview     : null,
      popupFile        : null,
      popupIsActive    : true,
      popupDescription : "",

      successMessage : "",
      errorMessage   : "",
    };
  }

  componentDidMount() {
    this.fetchLogo();
    this.fetchSocials();
    this.fetchPopup();
  }

  showSuccess = (msg) => { this.setState({ successMessage: msg, errorMessage: "" }); setTimeout(() => this.setState({ successMessage: "" }), 3000); };
  showError   = (msg) => { this.setState({ errorMessage: msg, successMessage: "" }); setTimeout(() => this.setState({ errorMessage: "" }), 4000); };

  // ════════════════════════════════
  //  1. LOGO SECTION
  // ════════════════════════════════

  fetchLogo = async () => {
    this.setState({ logoLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/setting/getSettings`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) {
        const data = json.data?.[0]?.[0] || json.data?.[0] || json.data || {};
        this.setState({
          logoData      : data,
          footerContent : data.footerDescription || data.footerDescription || "",
          logoLoading   : false,
        });
      } else { this.setState({ logoLoading: false }); }
    } catch { this.setState({ logoLoading: false }); this.showError("Cannot connect to API."); }
  };

  handleHeaderLogo = (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => this.setState({ headerLogoPreview: reader.result, headerLogoFile: file });
    reader.readAsDataURL(file);
  };

  handleFooterLogo = (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => this.setState({ footerLogoPreview: reader.result, footerLogoFile: file });
    reader.readAsDataURL(file);
  };

  saveLogo = async () => {
    const { headerLogoFile, footerLogoFile, footerContent, logoData } = this.state;
    this.setState({ logoSaving: true });
    try {
      const fd = new FormData();
      fd.append("footerdescription", footerContent);
      if (headerLogoFile) fd.append("headerurl", headerLogoFile);
      if (footerLogoFile) fd.append("footerurl",  footerLogoFile);
      if (logoData?.setting_id)   fd.append("setting_id", logoData.setting_id);

      const url = logoData?.setting_id
        ? `${API_URL}/api/setting/updatesettings`
        : `${API_URL}/api/setting/addSettings`;

      const res  = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState({ logoSaving: false });
      if (json.status) {
        this.showSuccess("Logo settings saved!");
        this.setState({ headerLogoPreview: null, headerLogoFile: null, footerLogoPreview: null, footerLogoFile: null });
        this.fetchLogo();
      } else { this.showError(json.message || "Save failed."); }
    } catch { this.setState({ logoSaving: false }); this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  2. SOCIAL MEDIA
  // ════════════════════════════════

  fetchSocials = async () => {
    this.setState({ socialLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/socialmedia/getSocialMedia`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) {
        this.setState({ socialList: json.data || json.data || [], socialLoading: false });
      } else { this.setState({ socialLoading: false }); }
    } catch { this.setState({ socialLoading: false }); this.showError("Cannot connect to API."); }
  };

  openSocialForm = (item = null) => {
    this.setState({
      socialView    : "form",
      editingSocial : item,
      socialForm    : item
        ? { platform: item.name || item.name || "", url: item.pageUrl || item.pageUrl || "", iconPreview: null, iconFile: null, saving: false }
        : emptySocialForm(),
    });
  };

  goToSocialList = () => { this.setState({ socialView: "list", editingSocial: null }); this.fetchSocials(); };

  handleSocialIcon = (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => this.setState((prev) => ({ socialForm: { ...prev.socialForm, iconPreview: reader.result, iconFile: file } }));
    reader.readAsDataURL(file);
  };

  saveSocial = async () => {
    const { socialForm, editingSocial } = this.state;
    if (!socialForm.platform.trim()) return this.showError("Platform name is required.");
    if (!socialForm.url.trim())      return this.showError("URL is required.");
    this.setState((prev) => ({ socialForm: { ...prev.socialForm, saving: true } }));
    try {
      const fd = new FormData();
      fd.append("name", socialForm.platform);
      fd.append("pageUrl",      socialForm.url);
      if (socialForm.iconFile) fd.append("logoUrl", null);
      if (editingSocial) fd.append("social_media_id", editingSocial.social_media_id || editingSocial.social_media_id);
      const url = editingSocial
        ? `${API_URL}/api/socialmedia/updateSocialMedia`
        : `${API_URL}/api/socialmedia/addSocialMedia`;
      const res  = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState((prev) => ({ socialForm: { ...prev.socialForm, saving: false } }));
      if (json.status) { this.showSuccess(editingSocial ? "Updated!" : "Saved!"); setTimeout(() => this.goToSocialList(), 1000); }
      else { this.showError(json.message || "Save failed."); }
    } catch { this.setState((prev) => ({ socialForm: { ...prev.socialForm, saving: false } })); this.showError("Cannot connect to API."); }
  };

  deleteSocial = async (idx) => {
    if (!window.confirm("Delete this social media link?")) return;
    try {
      const res  = await fetch(`${API_URL}/api/socialmedia/deleteSocialMedia`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id:idx }) });
      const json = await res.json();
      if (json.status) { this.showSuccess("Deleted."); this.fetchSocials(); }
      else { this.showError(json.message || "Delete failed."); }
    } catch { this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  3. POPUP
  // ════════════════════════════════

  fetchPopup = async () => {
    this.setState({ popupLoading: true });
    try {
      const res  = await fetch(`${API_URL}/api/popup/getPopup`, { method: "GET", headers: { "ngrok-skip-browser-warning": "true" } });
      const json = await res.json();
      if (json.status) {
        const data = json.data || null;
        this.setState({
          popupData        : data,
          popupIsActive    : data ? !!Number(data.is_active) : true,
          popupDescription : data?.description || "",
          popupLoading     : false,
        });
      } else { this.setState({ popupLoading: false }); }
    } catch { this.setState({ popupLoading: false }); this.showError("Cannot connect to API."); }
  };

  handlePopupImage = (e) => {
    const file = e.target.files[0]; if (!file) return;
    if (file.size > MAX_IMAGE_SIZE) { this.showError("Image size must be less than 3 MB."); e.target.value = ""; return; }
    const reader = new FileReader();
    reader.onloadend = () => this.setState({ popupPreview: reader.result, popupFile: file });
    reader.readAsDataURL(file);
  };

  togglePopupStatus = () => {
    this.setState((prev) => ({ popupIsActive: !prev.popupIsActive }));
  };

  savePopup = async () => {
    const { popupFile, popupIsActive, popupData, popupDescription } = this.state;

    if (!popupData?.popup_id && !popupFile) {
      return this.showError("Please upload a popup image.");
    }

    this.setState({ popupSaving: true });
    try {
      const fd = new FormData();
      fd.append("is_active", popupIsActive ? 1 : 0);
      fd.append("description", popupDescription);
      if (popupFile) fd.append("image", popupFile);
      if (popupData?.popup_id) fd.append("popup_id", popupData.popup_id);

      const url = popupData?.popup_id
        ? `${API_URL}/api/popup/updatePopup`
        : `${API_URL}/api/popup/addPopup`;

      const res  = await fetch(url, { method: "POST", body: fd });
      const json = await res.json();
      this.setState({ popupSaving: false });
      if (json.status) {
        this.showSuccess("Popup settings saved!");
        this.setState({ popupPreview: null, popupFile: null });
        this.fetchPopup();
      } else { this.showError(json.message || "Save failed."); }
    } catch { this.setState({ popupSaving: false }); this.showError("Cannot connect to API."); }
  };

  deletePopup = async () => {
    const { popupData } = this.state;
    if (!popupData?.popup_id) return;
    if (!window.confirm("Delete the popup? It will stop showing on the site.")) return;
    try {
      const res  = await fetch(`${API_URL}/api/popup/deletePopup`, { method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify({ id: popupData.popup_id }) });
      const json = await res.json();
      if (json.status) { this.showSuccess("Popup deleted."); this.setState({ popupData: null, popupPreview: null, popupFile: null, popupIsActive: true }); }
      else { this.showError(json.message || "Delete failed."); }
    } catch { this.showError("Cannot connect to API."); }
  };

  // ════════════════════════════════
  //  RENDER
  // ════════════════════════════════
  render() {
    const {
      activeTab,
      logoData, logoLoading, logoSaving,
      headerLogoPreview, headerLogoFile, footerLogoPreview, footerLogoFile, footerContent,
      socialView, socialList, socialLoading, socialForm, editingSocial,
      popupData, popupLoading, popupSaving, popupPreview, popupIsActive, popupDescription,
      successMessage, errorMessage,
    } = this.state;

    return (
      <div>
        <div className="page-header">
          <h2>Settings</h2>
          <p>Manage site logo, footer content and social media links.</p>
        </div>

        {successMessage && <div style={s.success}>{successMessage}</div>}
        {errorMessage   && <div style={s.error}>{errorMessage}</div>}

        {/* Tabs */}
        <div className="rsp-tab-row" style={s.tabRow}>
          {["logo", "social", "popup"].map((tab) => (
            <button key={tab} style={activeTab === tab ? s.tabActive : s.tab} onClick={() => this.setState({ activeTab: tab })}>
              {tab === "logo" ? "🖼 Logo & Footer" : tab === "social" ? "📱 Social Media" : "🔔 Popup"}
            </button>
          ))}
        </div>

        {/* ══════════════════════════════
            1. LOGO SECTION
        ══════════════════════════════ */}
        {activeTab === "logo" && (
          <div>
            {logoLoading ? (
              <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>
            ) : (
              <div className="card">

                {/* Section heading */}
                <div style={s.sectionHead}>
                  <h3 style={s.sectionTitle}>Logo & Branding</h3>
                  <p style={s.sectionSub}>Update site logos and footer description text.</p>
                </div>

                {/* ── Header Logo ── */}
                <div style={s.logoRow}>
                  <div style={s.logoInfo}>
                    <label style={s.label}>Header Logo</label>
                    <p style={s.hint}>Displayed in the top navigation bar. Recommended: transparent PNG, 200×60px.</p>
                  </div>
                  <div style={s.logoUploadArea}>
                    {/* Current */}
                    {/* ✅ API field: headerlogo */}
                    {logoData && logoData.headerlogo && !headerLogoPreview && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={{ fontSize: "11px", color: "#aaa", marginBottom: "6px" }}>Current:</p>
                        <img src={imgUrl(logoData.headerlogo)} alt="header logo" style={s.logoPreviewImg} />
                      </div>
                    )}
                    {headerLogoPreview ? (
                      <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                        <img src={headerLogoPreview} alt="new header logo" style={s.logoPreviewImg} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change<input type="file" accept="image/*" onChange={this.handleHeaderLogo} style={{ display: "none" }} /></label>
                          <button style={s.btnDeleteSm} onClick={() => this.setState({ headerLogoPreview: null, headerLogoFile: null })}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label style={s.uploadBoxSm}>
                        <p style={s.uploadText}>{logoData?.headerlogo ? "Click to replace" : "Click to upload"}</p>
                        <p style={s.uploadHint}>PNG with transparency recommended</p>
                        <input type="file" accept="image/*" onChange={this.handleHeaderLogo} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>
                </div>

                <div style={s.divider} />

                {/* ── Footer Logo ── */}
                <div style={s.logoRow}>
                  <div style={s.logoInfo}>
                    <label style={s.label}>Footer Logo</label>
                    <p style={s.hint}>Displayed in the footer section. Can be a white/light version of the logo.</p>
                  </div>
                  <div style={s.logoUploadArea}>
                    {/* ✅ API field: footerlogo */}
                    {logoData && logoData.footerlogo && !footerLogoPreview && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={{ fontSize: "11px", color: "#aaa", marginBottom: "6px" }}>Current:</p>
                        <div style={{ background: "#1a1a2e", padding: "10px", borderRadius: "6px", display: "inline-block" }}>
                          <img src={imgUrl(logoData.footerlogo)} alt="footer logo" style={s.logoPreviewImg} />
                        </div>
                      </div>
                    )}
                    {footerLogoPreview ? (
                      <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                        <div style={{ background: "#1a1a2e", padding: "10px", borderRadius: "6px" }}>
                          <img src={footerLogoPreview} alt="new footer logo" style={s.logoPreviewImg} />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change<input type="file" accept="image/*" onChange={this.handleFooterLogo} style={{ display: "none" }} /></label>
                          <button style={s.btnDeleteSm} onClick={() => this.setState({ footerLogoPreview: null, footerLogoFile: null })}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label style={s.uploadBoxSm}>
                        <p style={s.uploadText}>{logoData?.footerlogo ? "Click to replace" : "Click to upload"}</p>
                        <p style={s.uploadHint}>White/light version recommended</p>
                        <input type="file" accept="image/*" onChange={this.handleFooterLogo} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>
                </div>

                <div style={s.divider} />

                {/* ── Footer Content ── */}
                <div className="rsp-form-group" style={s.formGroup}>
                  <label style={s.label}>Footer Description / Content</label>
                  <p style={s.hint}>Short company description shown below the footer logo.</p>
                  <textarea
                    style={{ ...s.textarea, minHeight: "100px" }}
                    value={footerContent}
                    placeholder="TNA Events & Sports Pvt. Ltd. is an event management company committed to delivering integrated experiential communication solutions."
                    onChange={(e) => this.setState({ footerContent: e.target.value })}
                  />
                  <span style={{ fontSize: "11px", color: "#aaa" }}>{footerContent.length} characters</span>
                </div>

                {/* Save */}
                <div style={{ display: "flex", justifyContent: "flex-end", borderTop: "1px solid #f0f0f0", paddingTop: "16px" }}>
                  <button className="rsp-btn-save" style={s.btnSave} onClick={this.saveLogo} disabled={logoSaving}>
                    {logoSaving ? "Saving..." : "Save Logo Settings"}
                  </button>
                </div>

              </div>
            )}
          </div>
        )}

        {/* ══════════════════════════════
            2. SOCIAL MEDIA
        ══════════════════════════════ */}
        {activeTab === "social" && (
          <div>

            {/* Social List */}
            {socialView === "list" && (
              <div>
                <div className="rsp-list-top" style={s.listTopBar}>
                  <span style={s.countText}>{socialLoading ? "Loading..." : `${socialList.length} social link${socialList.length !== 1 ? "s" : ""} found`}</span>
                  <button className="rsp-btn-save" style={s.btnSave} onClick={() => this.openSocialForm()}>+ Add Social Link</button>
                </div>

                {socialLoading && <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>}
                {!socialLoading && socialList.length === 0 && (
                  <div style={s.emptyBox}>
                    <p style={{ ...s.emptyText, marginBottom: "12px" }}>No social media links found.</p>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={() => this.openSocialForm()}>+ Add First Link</button>
                  </div>
                )}

                {!socialLoading && socialList.map((item, i) => {
                  const platform = item.name || item.name || "Social";
                  const url      = item.pageUrl      || item.pageUrl || "";
                  const iconUrl  = item.icon     || item.iconUrl    || item.logo;
                  const preset   = SOCIAL_PLATFORMS.find(p => platform.toLowerCase().includes(p.label.toLowerCase().split("/")[0]));
                  return (
                    <div key={item.social_media_id || item.social_media_id || i} className="rsp-list-card" style={s.listCard}>

                      {/* Icon */}
                      {iconUrl ? (
                        <img src={imgUrl(iconUrl)} alt={platform} style={s.socialIcon} />
                      ) : (
                        <div style={{ ...s.socialIconPlaceholder, background: preset?.color || "#888" }}>
                          {(preset?.icon || platform.charAt(0)).toUpperCase()}
                        </div>
                      )}

                      {/* Details */}
                      <div style={{ flex: 1 }}>
                        <div style={s.cardTitle}>
                          {platform}
                          <span style={s.idBadge}>ID: {item.social_media_id || item.social_media_id}</span>
                        </div>
                        <a href={url} target="_blank" rel="noreferrer" style={{ fontSize: "12px", color: "#1565c0", wordBreak: "break-all" }}>
                          {url}
                        </a>
                      </div>

                      {/* Edit / Delete */}
                      <div className="rsp-action-btns" style={s.actionBtns}>
                        <button className="rsp-btn-edit" style={s.btnEdit}   onClick={() => this.openSocialForm(item)}>Edit</button>
                        <button className="rsp-btn-delete" style={s.btnDelete} onClick={() => this.deleteSocial(item.social_media_id || item.social_media_id)}>Delete</button>
                      </div>

                    </div>
                  );
                })}
              </div>
            )}

            {/* Social Form */}
            {socialView === "form" && (
              <div>
                <div className="rsp-form-top" style={s.formTopBar}>
                  <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToSocialList}>Back to List</button>
                  <h3 style={s.formTitle}>{editingSocial ? `Edit — ${editingSocial.platform || editingSocial.name}` : "Add Social Media Link"}</h3>
                </div>

                <div className="card">

                  {/* Platform selector */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Platform *</label>
                   
                    <input
                      className="rsp-input" style={s.input}
                      type="text"
                      value={socialForm.platform}
                      placeholder="Platform name (e.g. Facebook, Instagram)"
                      onChange={(e) => this.setState((prev) => ({ socialForm: { ...prev.socialForm, platform: e.target.value } }))}
                    />
                  </div>

                  {/* URL */}
                  <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Profile URL *</label>
                    <input
                      className="rsp-input" style={s.input}
                      type="text"
                      value={socialForm.url}
                      placeholder="https://www.facebook.com/tnaevents"
                      onChange={(e) => this.setState((prev) => ({ socialForm: { ...prev.socialForm, url: e.target.value } }))}
                    />
                  </div>

                  {/* Custom Icon Upload */}
                  {/* <div className="rsp-form-group" style={s.formGroup}>
                    <label style={s.label}>Custom Icon <span style={{ color: "#aaa", fontWeight: "400" }}>(optional — uses platform color if not set)</span></label>
                    {editingSocial && !socialForm.iconPreview && (editingSocial.icon || editingSocial.iconUrl || editingSocial.logo) && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={s.hint}>Current icon:</p>
                        <img src={imgUrl(editingSocial.icon || editingSocial.iconUrl || editingSocial.logo)} alt="icon" style={{ width: "48px", height: "48px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e8e8e8" }} />
                      </div>
                    )}
                    {socialForm.iconPreview ? (
                      <div style={{ display: "flex", gap: "12px", alignItems: "center" }}>
                        <img src={socialForm.iconPreview} alt="icon preview" style={{ width: "56px", height: "56px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e8e8e8" }} />
                        <div style={{ display: "flex", gap: "8px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change<input type="file" accept="image/*" onChange={this.handleSocialIcon} style={{ display: "none" }} /></label>
                          <button style={s.btnDeleteSm} onClick={() => this.setState((p) => ({ socialForm: { ...p.socialForm, iconPreview: null, iconFile: null } }))}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label style={{ ...s.uploadBoxSm, maxWidth: "300px" }}>
                        <p style={s.uploadText}>Click to upload icon</p>
                        <p style={s.uploadHint}>PNG/SVG — square icon (48×48px)</p>
                        <input type="file" accept="image/*" onChange={this.handleSocialIcon} style={{ display: "none" }} />
                      </label>
                    )}
                  </div> */}

                  <div className="rsp-form-actions" style={s.formActions}>
                    <button className="rsp-btn-back" style={s.btnBack} onClick={this.goToSocialList}>Cancel</button>
                    <button className="rsp-btn-save" style={s.btnSave} onClick={this.saveSocial} disabled={socialForm.saving}>
                      {socialForm.saving ? "Saving..." : editingSocial ? `Update ${socialForm.platform || "Link"}` : `Save ${socialForm.platform || "Link"}`}
                    </button>
                  </div>

                </div>
              </div>
            )}
          </div>
        )}

        {/* ══════════════════════════════
            3. POPUP
        ══════════════════════════════ */}
        {activeTab === "popup" && (
          <div>
            {popupLoading ? (
              <div style={s.emptyBox}><p style={s.emptyText}>Loading...</p></div>
            ) : (
              <div className="card">

                <div style={s.sectionHead}>
                  <h3 style={s.sectionTitle}>Site Popup</h3>
                  <p style={s.sectionSub}>Upload the popup image and control whether it's shown on the site.</p>
                </div>

                <div style={s.logoRow}>
                  <div style={s.logoInfo}>
                    <label style={s.label}>Popup Image</label>
                    <p style={s.hint}>Shown as an on-load popup on the public site. Recommended: PNG/JPG, under 3 MB.</p>
                  </div>
                  <div style={s.logoUploadArea}>
                    {popupData && popupData.image_url && !popupPreview && (
                      <div style={{ marginBottom: "10px" }}>
                        <p style={{ fontSize: "11px", color: "#aaa", marginBottom: "6px" }}>Current:</p>
                        <img src={imgUrl(popupData.image_url)} alt="popup" style={{ maxWidth: "220px", maxHeight: "220px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e8e8e8", display: "block" }} />
                      </div>
                    )}
                    {popupPreview ? (
                      <div style={{ display: "flex", gap: "12px", alignItems: "flex-start" }}>
                        <img src={popupPreview} alt="new popup" style={{ maxWidth: "220px", maxHeight: "220px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e8e8e8" }} />
                        <div style={{ display: "flex", flexDirection: "column", gap: "6px" }}>
                          <label className="rsp-btn-dark" style={s.btnDark}>Change<input type="file" accept="image/*" onChange={this.handlePopupImage} style={{ display: "none" }} /></label>
                          <button style={s.btnDeleteSm} onClick={() => this.setState({ popupPreview: null, popupFile: null })}>Remove</button>
                        </div>
                      </div>
                    ) : (
                      <label style={s.uploadBoxSm}>
                        <p style={s.uploadText}>{popupData?.image_url ? "Click to replace" : "Click to upload"}</p>
                        <p style={s.uploadHint}>PNG or JPG, up to 3 MB</p>
                        <input type="file" accept="image/*" onChange={this.handlePopupImage} style={{ display: "none" }} />
                      </label>
                    )}
                  </div>
                </div>

                <div style={s.divider} />

                <div className="rsp-form-group" style={s.formGroup}>
                  <label style={s.label}>Description</label>
                  <RichTextEditor
                    value={popupDescription}
                    onChange={(val) => this.setState({ popupDescription: val })}
                  />
                </div>

                <div style={s.divider} />

                <div style={s.logoRow}>
                  <div style={s.logoInfo}>
                    <label style={s.label}>Status</label>
                    <p style={s.hint}>Turn the popup on or off without deleting the image.</p>
                  </div>
                  <div style={s.logoUploadArea}>
                    <button
                      type="button"
                      onClick={this.togglePopupStatus}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "10px",
                        padding: "10px 16px", borderRadius: "8px", cursor: "pointer",
                        border: `1px solid ${popupIsActive ? "#c8e6c9" : "#e0e0e0"}`,
                        background: popupIsActive ? "#e8f5e9" : "#f5f5f5",
                        fontSize: "13px", fontWeight: "600",
                        color: popupIsActive ? "#2e7d32" : "#888",
                      }}
                    >
                      <span style={{
                        width: "34px", height: "18px", borderRadius: "10px",
                        background: popupIsActive ? "#2e7d32" : "#bbb",
                        position: "relative", display: "inline-block", transition: "background 0.15s",
                      }}>
                        <span style={{
                          width: "14px", height: "14px", borderRadius: "50%", background: "#fff",
                          position: "absolute", top: "2px", left: popupIsActive ? "18px" : "2px",
                          transition: "left 0.15s",
                        }} />
                      </span>
                      {popupIsActive ? "Active" : "Inactive"}
                    </button>
                  </div>
                </div>

                <div style={{ ...s.formActions, marginTop: "24px" }}>
                  {popupData?.popup_id && (
                    <button style={s.btnDeleteSm} onClick={this.deletePopup}>Delete Popup</button>
                  )}
                  <button className="rsp-btn-save" style={s.btnSave} onClick={this.savePopup} disabled={popupSaving}>
                    {popupSaving ? "Saving..." : "Save Popup"}
                  </button>
                </div>

              </div>
            )}
          </div>
        )}

      </div>
    );
  }
}

const s = {
  success          : { background: "#e8f5e9", color: "#2e7d32", border: "1px solid #c8e6c9", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  error            : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", borderRadius: "8px", padding: "12px 16px", marginBottom: "16px", fontSize: "14px" },
  tabRow           : { display: "flex", gap: "10px", borderBottom: "2px solid #e8e8e8", marginBottom: "20px" },
  tab              : { padding: "10px 20px", background: "none", border: "none", borderBottom: "3px solid transparent", fontSize: "14px", color: "#888", cursor: "pointer", marginBottom: "-2px", fontWeight: "500" },
  tabActive        : { padding: "10px 20px", background: "none", border: "none", borderBottom: "3px solid #e8a020", fontSize: "14px", color: "#e8a020", cursor: "pointer", marginBottom: "-2px", fontWeight: "600" },
  // Logo section
  sectionHead      : { marginBottom: "24px", paddingBottom: "16px", borderBottom: "1px solid #f0f0f0" },
  sectionTitle     : { fontSize: "16px", color: "#1a1a2e", fontWeight: "700", margin: "0 0 4px" },
  sectionSub       : { fontSize: "13px", color: "#888", margin: 0 },
  logoRow          : { display: "grid", gridTemplateColumns: "280px 1fr", gap: "24px", alignItems: "start", marginBottom: "20px" },
  logoInfo         : { },
  logoUploadArea   : { },
  logoPreviewImg   : { maxWidth: "180px", maxHeight: "70px", objectFit: "contain", display: "block" },
  uploadBoxSm      : { display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", border: "2px dashed #ddd", borderRadius: "10px", padding: "20px 16px", cursor: "pointer", background: "#fafafa", textAlign: "center" },
  divider          : { borderTop: "1px solid #f0f0f0", margin: "20px 0" },
  // Social list
  listTopBar       : { display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "16px" },
  countText        : { fontSize: "14px", color: "#888" },
  listCard         : { background: "white", borderRadius: "10px", padding: "16px 18px", border: "1px solid #e8e8e8", marginBottom: "12px", display: "flex", alignItems: "center", gap: "14px" },
  cardTitle        : { fontSize: "15px", color: "#1a1a2e", fontWeight: "600", display: "flex", alignItems: "center", gap: "8px", marginBottom: "4px" },
  idBadge          : { background: "#f0f2f5", color: "#888", border: "1px solid #e0e0e0", borderRadius: "10px", padding: "2px 8px", fontSize: "11px", fontWeight: "400" },
  socialIcon       : { width: "44px", height: "44px", objectFit: "contain", borderRadius: "8px", border: "1px solid #e8e8e8", flexShrink: 0 },
  socialIconPlaceholder: { width: "44px", height: "44px", borderRadius: "8px", display: "flex", alignItems: "center", justifyContent: "center", color: "#fff", fontSize: "16px", fontWeight: "800", flexShrink: 0 },
  actionBtns       : { display: "flex", flexDirection: "column", gap: "6px", flexShrink: 0 },
  btnEdit          : { background: "#e3f2fd", color: "#1565c0", border: "1px solid #bbdefb", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  btnDelete        : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", padding: "6px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600", minWidth: "64px" },
  btnDeleteSm      : { background: "#ffebee", color: "#c62828", border: "1px solid #ffcdd2", padding: "5px 12px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600" },
  emptyBox         : { background: "white", borderRadius: "10px", padding: "48px 20px", border: "1px solid #e8e8e8", textAlign: "center" },
  emptyText        : { color: "#aaa", fontSize: "14px" },
  formTopBar       : { display: "flex", alignItems: "center", gap: "14px", marginBottom: "16px" },
  formTitle        : { fontSize: "16px", color: "#1a1a2e", margin: 0 },
  formActions      : { display: "flex", justifyContent: "flex-end", gap: "10px", borderTop: "1px solid #f0f0f0", paddingTop: "16px" },
  formGroup        : { marginBottom: "20px" },
  label            : { display: "block", fontSize: "13px", color: "#555", fontWeight: "600", marginBottom: "6px" },
  input            : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", fontFamily: "Arial, sans-serif", boxSizing: "border-box" },
  textarea         : { width: "100%", padding: "10px 14px", border: "1px solid #ddd", borderRadius: "8px", fontSize: "14px", outline: "none", resize: "vertical", fontFamily: "Arial, sans-serif", boxSizing: "border-box" },
  uploadText       : { fontSize: "14px", color: "#555", marginBottom: "4px" },
  uploadHint       : { fontSize: "11px", color: "#aaa" },
  hint             : { fontSize: "12px", color: "#888", marginTop: "4px", marginBottom: "6px", display: "block" },
  btnDark          : { background: "#1a1a2e", color: "#fff", border: "none", padding: "7px 14px", borderRadius: "6px", fontSize: "12px", cursor: "pointer", fontWeight: "600" },
  btnSave          : { background: "#e8a020", color: "#fff", border: "none", padding: "10px 20px", borderRadius: "8px", fontSize: "14px", fontWeight: "600", cursor: "pointer" },
  btnBack          : { background: "#f0f2f5", color: "#333", border: "1px solid #ddd", padding: "9px 16px", borderRadius: "8px", fontSize: "13px", cursor: "pointer", fontWeight: "500" },
};

export default Settings;